import { useTranslation } from 'react-i18next'

import { Icon } from '@lib/components'

import styles from './styles.module.scss'

export const MessageSpamIndicator = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.spamIndicator}>
      <Icon className={styles.spamIcon} path={'icons/icon-warning-red'}/>
      <div className={styles.spamStatusText}>
        {t('Chat.Message.Spam')}
      </div>
    </div>
  )
}
